export default "__VITE_ASSET__y4BC5S5Y__"